<template>
  <div class="markettrends-tabheader" :class="{tabheader: !isWidget}">
    <div class="city-info" v-if="city">
      <span class="city-circle" :style="{background:city.color}"></span>{{city.name}}
    </div>
    <span class="median-title">{{ tabHeader.metric_title }}<br></span>
   <span class="median-value">{{ tabHeader.value }}</span>
   <br>
    <div class="trend-text">
      <span v-if="tabHeader.monthly_value"
        :class="(tabHeader.monthly_value.indexOf('+') === 0 || !Number(tabHeader.monthly_value.split('%')[0])) ? 'raise': 'reduce'">
        {{tabHeader.monthly_value}} <i class="f7 icon-arrow-down" :class="{'icon-arrow-up': tabHeader.monthly_value.indexOf('+') === 0 || !Number(tabHeader.monthly_value.split('%')[0])}"></i>
      </span> <h6 v-if="tabHeader.monthly_value"> M/M:</h6>
      <span v-if="tabHeader.yearly_value"
        :class="(tabHeader.yearly_value.indexOf('+') === 0 || !Number(tabHeader.value.split('%')[0])) ? 'raise': 'reduce'">
        {{tabHeader.yearly_value}} <i class="f7 icon-arrow-down" :class="{'icon-arrow-up': tabHeader.yearly_value.indexOf('+') === 0 || !Number(tabHeader.value.split('%')[0])}"></i>
      </span> <h6 v-if="tabHeader.yearly_value">Y/Y:</h6>
    </div>
  </div>
</template>

<script src="./markettrends-tabheader.js"></script>
<style lang="scss">
@use './markettrends-tabheader.scss' as *;
</style>